/**
 * 合計CPA（オファーあり）に含めない割引（クーポン）の一覧と判定。
 *
 * 株主優待・取引先の福利厚生など、割引の費用をマーケの予算で持たないクーポンは、オファー（入会時の割引）としては
 * 数えるが合計CPA（オファーあり）の分子には足さない（獲得数には含める）。判定はクーポン名で行い、書き手（日次バッチが
 * 内訳タブの H 列に理由を書く）と読み手（予実の取り込み・合計CPA・オファーの内訳の画面）が同じ関数を使う。
 * 一覧はコードに持ち、増やすときは PR で足す。判定をクーポン名で行うのは、内訳タブ・BQ（`plan__offer_daily`）に
 * クーポンの ID が無く名前しか無いため。読み手は表示・集計の時点で外すので、BQ の古い行を書き換えずに、
 * オファーを数え始めた日までさかのぼって外れる。名前が変わると外れなくなるので、日次バッチが毎朝 ID から今の名前を
 * 引いて一覧の名前と比べ、食い違えばエラーのログを出す。
 *
 * @graph-stack ac-mens-hub
 * @graph-domain Marketing
 * @graph-business 合計CPA（オファーあり）に含めない割引（株主優待・福利厚生）の一覧と、クーポン名から含めない理由を返す判定を、内訳タブを書く日次バッチと合計CPA・内訳を出す Hub で共有する
 * @graph-connects none
 */
/** 株主優待の理由。 @graph-connects none */
const SHAREHOLDER_BENEFIT_REASON = '株主優待（マーケ予算外）';
/** 福利厚生の理由。 @graph-connects none */
const EMPLOYEE_BENEFIT_REASON = '福利厚生（会社が請求書で負担）';
/**
 * 合計CPA（オファーあり）に含めないクーポンの一覧。画面の「CPAに含めない割引」の表はこの並びで、期間内に
 * 使われていなくても全部出す。名前は DB の実際の名前どおり（全角・半角の括弧の混在も含む）。
 * @graph-stack ac-mens-hub
 * @graph-domain Marketing
 * @graph-business 合計CPA（オファーあり）に含めないクーポン（株主優待・SMBC福利厚生）を ID・名前・理由で名指しする
 * @graph-connects none
 */
export const OFFER_CPA_EXCLUDED_COUPONS = [
    {
        couponMasterId: '01a022f8-e07a-71bf-94a9-09056c8cda51',
        couponName: '2025年度株主優待クーポン',
        reason: SHAREHOLDER_BENEFIT_REASON,
    },
    {
        couponMasterId: '019fd0e1-4391-73b9-a5d3-323a856b3a73',
        couponName: 'SMBC福利厚生（全社員様向け）',
        reason: EMPLOYEE_BENEFIT_REASON,
    },
    {
        couponMasterId: '019fd0de-61b8-729a-be92-f6a5acbe5ad6',
        couponName: 'SMBC福利厚生（新任管理職社員様向け）',
        reason: EMPLOYEE_BENEFIT_REASON,
    },
    {
        couponMasterId: '019fd0dd-11d4-7301-a49a-c9b11591f8bc',
        couponName: 'SMBC福利厚生（新入社員様向け）',
        reason: EMPLOYEE_BENEFIT_REASON,
    },
    {
        couponMasterId: '019fd0df-b4e8-73c8-9ad5-733bf04fc632',
        couponName: 'SMBC福利厚生(育休復帰社員様向け）',
        reason: EMPLOYEE_BENEFIT_REASON,
    },
];
/** クーポン名から理由を引く表。 @graph-connects none */
const REASON_BY_COUPON_NAME = new Map(OFFER_CPA_EXCLUDED_COUPONS.map((coupon) => [coupon.couponName, coupon.reason]));
/**
 * クーポン名が合計CPA（オファーあり）に含めないクーポンなら、その理由を返す。含めるクーポンなら null。
 * 名前の完全一致で判定する（部分一致にすると、他社の社員向けなど実顧客のクーポンまで外れる）。
 * @graph-stack ac-mens-hub
 * @graph-domain Marketing
 * @graph-business クーポン名が合計CPAに含めない割引かを判定し、含めない理由を返す（書き手と読み手が同じ判定を使う）
 * @graph-connects OFFER_CPA_EXCLUDED_COUPONS [references] 含めないクーポンの一覧
 */
export function offerCpaExclusionReason(couponName) {
    return REASON_BY_COUPON_NAME.get(couponName) ?? null;
}
//# sourceMappingURL=offer-cpa-exclusion.js.map